import { useState } from "react";
import { useTranslation } from "react-i18next";
import AppInputNew from "@/components/Core/AppInput/AppInputNew";
import AppSelect from "@/components/Core/AppSelect/AppSelect";
import AppText from "@/components/Core/AppText/AppText";
import Button from "@/components/Core/Button/Button";
import { useOrganisation, useUpdateOrganisation } from "@/networking/organisation.hooks";
import { SettingsLeaf } from "./SettingsLeafLayout";

const EMPLOYEE_IDENTIFIER_OPTIONS = [
	{ id: "EMPLOYEE_NUMBER", name: "Anställningsnummer" },
	{ id: "SSN", name: "Personnummer (utan sekelsiffror)" },
];

const LonPage = () => {
	const { t } = useTranslation();
	const { data: organisation } = useOrganisation();
	const { mutate: updateOrganisation } = useUpdateOrganisation();
	const [cfar, setCfar] = useState(organisation?.salarySettings.cfar || "");
	const [employeeIdentifier, setEmployeeIdentifier] = useState(
		organisation?.salarySettings.employeeIdentifier || "EMPLOYEE_NUMBER"
	);

	function save() {
		if (organisation) {
			updateOrganisation({
				salarySettings: { ...organisation.salarySettings, cfar, employeeIdentifier },
			});
		}
	}

	return (
		<SettingsLeaf title="Lön">
			<AppInputNew
				label="Lönesystem"
				value={organisation?.salarySettings.exportType || ""}
				disabled
				description="System för lön/HR som Origo exporterar löner till. Kontakta Origo om ni önskar integrera mot ett annat system."
			/>
			<div className="space-y-2">
				<AppInputNew
					label={t("organisation.economy.cfar")}
					value={cfar}
					onChangeText={setCfar}
					description={t("organisation.economy.cfarDescription")}
				/>
				{organisation?.salarySettings.exportType?.startsWith("HOGIA") && (
					<div>
						<AppSelect
							label="Identifierare för anställda"
							options={EMPLOYEE_IDENTIFIER_OPTIONS}
							value={employeeIdentifier}
							onChange={(value) => setEmployeeIdentifier(value as "EMPLOYEE_NUMBER" | "SSN")}
							width="280px"
							margin="0"
						/>
						<AppText margin="0.35rem 0 0 0.15rem" size="xs" color="grayText">
							Vad Hogia-exporterna använder som anställningsnummer, i både lönefilen och
							personalfilen.
						</AppText>
					</div>
				)}
				<Button onClick={save}>{t("SAVE")}</Button>
			</div>
		</SettingsLeaf>
	);
};

export default LonPage;
